import React, { useMemo } from "react";

import { CaretUpIcon, CaretDownIcon, EqualsIcon } from "@phosphor-icons/react";

import * as styles from "./styles";

export function ValueIndicator({
  comparison,
}: {
  comparison: "higher" | "lower" | "equal";
}) {
  const Icon = useMemo(() => {
    switch (comparison) {
      case "higher":
        return CaretUpIcon;
      case "lower":
        return CaretDownIcon;
      default:
        return EqualsIcon;
    }
  }, [comparison]);

  return (
    <div
      className={styles.container}
      data-testid="value-indicator"
      data-comparison={comparison}
    >
      <Icon className={styles.icon} />
    </div>
  );
}
